import { createSlice } from "@reduxjs/toolkit";
import dateFormat from "dateformat";
import {
  onSetLoaded, onSetError, onSetLoadedCreate, onSetLoadedDelete, onSetLoadedUpdate,
  onErrorCreate, onErrorUpdate, onErrorDelete, createFailed, updateFailed, deleteFailed
} from './../utils/loadedError';

const deleteRecords = (initialState, data) => {
  switch (data.action) {
    case "restore":
      return initialState.deletedData.filter((item) => item !== data.record);
    case "delete":
      return [...initialState.deletedData, data.record];
    default:
      return initialState.deletedData;
  }
};

function* idMaker() {
  var index = -1;
  while (true) yield index--;
}

let it = idMaker();

const initialcustomersState = {
  data: [],
  changedData: [],
  newData: [],
  Error: null,
  isLoaded: false,
  isLoadedCreate: true,
  isLoadedUpdate: true,
  isLoadedDelete: true,
  errorCreate: null,
  errorUpdate: null,
  errorDelete: null,
};

const customersSlice = createSlice({
  name: "customers",
  initialState: initialcustomersState,
  reducers: {
    onClearStore(state) {
      state.data = [];
      state.changedData = [];
      state.deletedData = [];
      state.newData = [];
      state.isLoaded = false;
      state.Error = null;
      state.isLoadedCreate = true;
      state.isLoadedDelete = true;
      state.isLoadedUpdate = true;
      state.errorCreate = null;
      state.errorDelete = null;
      state.errorUpdate = null;
    },
    
    onInitial(state, action) {
      state.data = action.payload;
      state.changedData = action.payload;
      state.deletedData = [];
      state.newData = [];
      state.isLoaded = true;
      state.Error = null;
      state.isLoadedCreate = true;
      state.isLoadedDelete = true;
      state.isLoadedUpdate = true;
      state.errorCreate = null;
      state.errorDelete = null;
      state.errorUpdate = null;
    },

    onSetLoaded,
    onSetError,
    onSetLoadedCreate,
    onSetLoadedUpdate,
    onSetLoadedDelete,
    onErrorCreate,
    onErrorUpdate,
    onErrorDelete,
    createFailed,
    updateFailed,
    deleteFailed,

    deleteDataSuccess(state, action) {
      state.data = state.data.filter((item) => item.id !== action.payload);
      state.changedData = state.changedData.filter(
        (item) => item.id !== action.payload
      );
      state.deletedData = state.deletedData.filter(
        (item) => item !== action.payload
      );
      // state.isLoadedDelete = true;
    },

    updateDataSuccess(state, action) {
      state.data = state.data.map((item) =>
        item.id === action.payload.id ? action.payload : item
      );
      state.changedData = state.changedData.map((item) =>
        item.id === action.payload.id ? action.payload : item
      );
      // state.isLoadedUpdate = true;
    },

    createDataSuccess(state, action) {
      state.data = [...state.data, action.payload.data];
      state.changedData = [...state.changedData, action.payload.data];
      state.newData = state.newData.filter(
        (item) => item.id !==action.payload.oldId
      );
      // state.isLoadedCreate = true;
    },

    changeData(state, action) {
      const record = action.payload.record;
      const property = action.payload.property;
      const store = action.payload.store;
      state[store] = state[store].map((item) =>
        item.id === record.id ? { ...item, [property]: record[property] } : item
      );
    },

    deleteData(state, action) {
      const Id = action.payload.record;
      const store = action.payload.store;
      if (store === "changedData") {
        state.deletedData = [...deleteRecords(state, action.payload)];
      } else {
        state.newData = state.newData.filter((item) => item.id !==Id);
      }
    },

    createData(state, action) {
      let newRecord = {
        id: it.next().value,
        name: '',
        portal: null,
        isOPI: false,
        tgGroupId: '',
      };
      state.newData = [...state.newData, newRecord];
    },
  },
});

export const customersActions = customersSlice.actions;
export default customersSlice.reducer;
